import { render } from "./App.vue?vue&type=template&id=4030398c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4030398c&lang=scss"

import exportComponent from "D:\\laragon\\www\\SDL\\blims\\blims-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__